import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      position: 'relative',
      padding: theme.spacing(3),
      '&$notActive': {
        padding: theme.spacing(3),
        '& $title': {
          color: COLORS.gray.gray30,
        },
      },
    },
    notActive: {},
    titleRow: {
      display: 'flex',
    },
    optional: {
      color: COLORS.gray.gray40,
      fontWeight: theme.typography.fontWeightRegular,
    },
    resetButton: {
      marginBottom: 'auto',
      marginLeft: 'auto',
      fontWeight: theme.typography.fontWeightMedium,
    },
    tag: {
      display: 'inline-block',
      padding: theme.spacing(0.375, 0.75, 0.25),
      backgroundColor: COLORS.gray.gray80,
      color: COLORS.gray.gray30,
      textTransform: 'capitalize',
      borderRadius: theme.shape.borderRadiusMinimal,
      width: 'max-content',
      fontSize: theme.typography.pxToRem(10),
      lineHeight: theme.typography.pxToRem(14),
      fontWeight: theme.typography.fontWeightMedium,
    },
    subtitle: {
      color: COLORS.gray.gray40,
      lineHeight: theme.typography.pxToRem(16),
      marginTop: theme.spacing(1),
    },
    activeFooter: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'end',
      marginTop: theme.spacing(3),
    },
    activeFooterSlot: {
      flex: 1,
    },
    footerButtons: {
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'center',
      gap: theme.spacing(1),
    },
    errorMessage: {
      color: COLORS.error.default,
    },
    submitButton: {},
    editButton: {
      position: 'absolute',
      top: theme.spacing(2),
      right: theme.spacing(2),
    },
  }),
  { name: 'DraftStepBlock' }
);
